{
  "messages": {
    "maximumInSizeOnlyOneImageTextZipOrSpreadsheetAllowedToUploadMultipleDocsZipFirstThenUpload": "Máximo {size} en tamaño. Solo se permite {imageLimit}, {typeLimitText}, {typeLimitZip} o {typeLimitSpreadsheet}. Para subir múltiples documentos, comprima primero y luego suba.",
    "maximumInSizePerFileOnlyImageTextZipSpreadsheetAllowed": "Máximo {size} en tamaño por archivo. Máximo {count} archivos. Solo se permite {image}, {text}, {zip} o {spreadsheet}.",
    "oneImage": "UNA imagen",
    "sizeInMegabytes": "{size} MB",
    "uploadDocument": "Subir documento",
    "uploadDocuments": "Subir documentos"
  }
}
